import React from "react";
import { Button } from "react-bootstrap";
import "./styles/ModalPrimaryButton.css";

export default function ModalPrimaryButton({
  title,
  className,
  startIcon: StartIcon,
  endIcon: EndIcon,
  ...props
}) {
  return (
    <Button
      className={`modal-primary-button sf-modal-primary ${
        className ? className : ""
      }`}
      {...props}
    >
      <div>
        {StartIcon ? <StartIcon className="start-icon" /> : null}
      </div>
      {title}
    </Button>
  );
}
